import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Box, IconButton, Tooltip } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import type { Moment } from "moment";

interface Props {
	start: Moment;
	end: Moment;
	onStartChange: (date: Moment | null) => void;
	onEndChange: (date: Moment | null) => void;
	onReset: () => void;
	isLoading: boolean;
}

// Start, End and one action, as in the legacy toolbar. There is no Excel button
// either — the legacy template never declared one.
export const TimerSpeedReportToolbar = ({
	start,
	end,
	onStartChange,
	onEndChange,
	onReset,
	isLoading,
}: Props) => (
	<Box
		sx={{
			display: "flex",
			alignItems: "center",
			gap: 1,
			px: 1.5,
			py: 0.75,
			flexWrap: "wrap",
		}}
	>
		<Box sx={{ minWidth: 150, maxWidth: 170 }}>
			<DatePicker
				label="Start"
				format="MM/DD/YYYY"
				value={start}
				maxDate={end}
				onChange={onStartChange}
				slotProps={{ textField: { size: "small", fullWidth: true } }}
			/>
		</Box>
		<Box sx={{ minWidth: 150, maxWidth: 170 }}>
			<DatePicker
				label="End"
				format="MM/DD/YYYY"
				value={end}
				minDate={start}
				onChange={onEndChange}
				slotProps={{ textField: { size: "small", fullWidth: true } }}
			/>
		</Box>

		{/* Changing a date already refetches, so a search button would have nothing
		    to do. This one puts the range back to the three days the screen opens
		    on and reloads it, which is also how you pick up billets rolled since
		    the page was opened — the report does not poll. */}
		<Tooltip title="Reset to the default range">
			<span>
				<IconButton
					onClick={onReset}
					disabled={isLoading}
					size="small"
					sx={{
						bgcolor: "primary.main",
						color: "white",
						width: 28,
						height: 28,
						"&:hover": { bgcolor: "primary.dark" },
						"&.Mui-disabled": {
							bgcolor: "action.disabledBackground",
							color: "action.disabled",
						},
					}}
				>
					<RestartAltIcon sx={{ fontSize: 18 }} />
				</IconButton>
			</span>
		</Tooltip>
	</Box>
);
